"use client"

import { cn } from "@/shared/lib/utils"

interface ToolSupplyBlankLineRowProps {
    isVolunteer?: boolean
    className?: string
}

export default function ToolSupplyBlankLineRow({
    isVolunteer = false,
    className,
}: ToolSupplyBlankLineRowProps) {
    return (
        <div
            className={cn(
                "gap-2 items-center",
                isVolunteer
                    ? "grid grid-cols-[1fr_3rem_3rem] print:grid-cols-[minmax(0,1fr)_3rem_3rem]"
                    : "grid grid-cols-[1fr_3rem_3rem_auto] print:grid-cols-[minmax(0,1fr)_3rem_3rem]",
                className
            )}
        >
            <div className="text-sm text-gray-700 min-w-0 overflow-hidden pr-2 print:pr-4">
                <span className="inline-block w-full border-b-2 border-gray-400 pb-0.5">
                    {" ".repeat(40)}
                </span>
            </div>
            <div className="flex justify-center">
                <input
                    type="checkbox"
                    className="w-5 h-5"
                    disabled
                    readOnly
                    aria-hidden
                    tabIndex={-1}
                />
            </div>
            <div className="flex justify-center">
                <input
                    type="checkbox"
                    className="w-5 h-5"
                    disabled
                    readOnly
                    aria-hidden
                    tabIndex={-1}
                />
            </div>
            {!isVolunteer && <div className="w-8 print:hidden" aria-hidden />}
        </div>
    )
}
